import { isPlatformBrowser } from '@angular/common';
import {
  ElementRef,
  Inject,
  inject,
  Injectable,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { ApplicationConfig } from '../../utils/config';
import { LoggingService } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class CommonServiceExtended {
  appConfig = inject(ApplicationConfig);
  loggingService = inject(LoggingService);
  @Inject(PLATFORM_ID) platformId = Object;
  dragModalContainers(nativeData: ElementRef, rendererElement: Renderer2) {
    try {
      if (this.appConfig.get('APP_DISABLE_LEGACY') === 'false') {
        const rootDocList = this.rootDocList(nativeData);
        const modalContainerData = this.getModalContainer(rootDocList);
        this.addRendererElement(
          rendererElement,
          modalContainerData,
          rootDocList
        );
      }
    } catch (err) {
      this.loggingService.log('Caught Error: ' + err);
    }
  }

  addRendererElement(
    rendererElement: Renderer2,
    modalContainerData: Element | null,
    rootDocList: Document
  ) {
    const bsBackdrop = rootDocList.querySelector('bs-modal-backdrop');
    const freshAirContainer = rootDocList.querySelector('header');
    if (modalContainerData && bsBackdrop) {
      rendererElement.addClass(bsBackdrop, 'show');
      rendererElement.addClass(modalContainerData, 'show');
      rendererElement.addClass(modalContainerData, 'fresh-air');
      rendererElement.appendChild(freshAirContainer, bsBackdrop);
      rendererElement.appendChild(freshAirContainer, modalContainerData);
      const modalContainerChild = modalContainerData.children[0];
      if (modalContainerChild) {
        this.rendererElement(
          rendererElement,
          modalContainerChild,
          modalContainerData
        );
      }
    }
  }

  checkIEOrEdgeBrowser() {
    if (isPlatformBrowser(this.platformId)) {
      const isIEOrEdge = /msie\s|trident\/|edge\//i.test(
        window.navigator.userAgent
      );
      if (isIEOrEdge) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  rootDocList(nativeData: ElementRef) {
    let rootDocList;
    try {
      if (this.checkIEOrEdgeBrowser() === true) {
        rootDocList = document;
      } else {
        rootDocList = nativeData.nativeElement.ownerDocument;
      }
    } catch (e) {
      rootDocList = document.querySelector('body');
    }
    return rootDocList;
  }

  getModalContainer(rootDocList: Document) {
    let modalContainerData;
    if (rootDocList.getElementsByTagName('modal-container').length > 1) {
      modalContainerData =
        rootDocList.getElementsByTagName('modal-container')[1];
    } else {
      modalContainerData = rootDocList.querySelector('modal-container');
    }
    return modalContainerData;
  }

  rendererElement(
    rendererElement: Renderer2,
    modalContainerChild: Element,
    modalContainerData: Element
  ) {
    let footerExist;
    rendererElement.removeClass(modalContainerChild, 'footer');
    if (modalContainerChild.classList.value) {
      footerExist = modalContainerChild.classList.value.includes('hp-footer');
    }

    const searchModalContainerFooter = modalContainerData.querySelector(
      '.footer-search-modal'
    );
    if (footerExist) {
      rendererElement.removeClass(modalContainerChild, 'hp-footer');
    }
    if (searchModalContainerFooter) {
      rendererElement.addClass(modalContainerChild, 'hp-footer');
    }
    rendererElement.addClass(modalContainerData, 'd-block');
  }

  focusModalContainers(nativeData: ElementRef) {
    if (this.appConfig.get('APP_DISABLE_LEGACY') === 'false') {
      const rootDocList = this.rootDocList(nativeData);
      if (rootDocList) {
        const modalContainerData = rootDocList.querySelector('modal-container');
        const searchModalContainer =
          modalContainerData.querySelector('.search-flyout');
        if (searchModalContainer !== null) {
          searchModalContainer.querySelector('#search_input').focus();
        } else {
          modalContainerData.focus();
        }
      }
    }
  }
}
